import React from "react";
import PropTypes from "prop-types";

import { getPages } from "./getPages";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";
import t from "../../lib/translate";

import * as styles from "./component.module.less";

/*
[PREV] [FIRST] [SPACER] PAGES [SPACER] [LAST] [NEXT]
*/

function BasePager({
    className = '',
    currentPage = 1,
    lastPage,
    onRenderPage,
}) {
    if (lastPage <= 1) {
        return null;
    }

    const pages = getPages(currentPage, lastPage);

    return (
        <ol className={gcs(styles.pager, className)}>

            {/* [PREV] */}
            {currentPage > 1 && (
                <li className={gcs(styles.prev)}>
                    {onRenderPage(currentPage - 1, false, t`pager.prev.label`)}
                </li>
            )}

            {/* [FIRST] */}
            {pages[0] > 1 && (
                <li className={gcs(styles.page)}>
                    {onRenderPage(1, false, 1)}
                </li>
            )}

            {/* [SPACER] */}
            {pages[0] > 2 && (
                <li className={styles.spacer}>...</li>
            )}

            {/* PAGES */}
            {pages.map((page) => (
                <li key={page.toString()} className={gcs(styles.page, [currentPage === page, styles.active])}>
                    {onRenderPage(page, currentPage === page, page)}
                </li>
            ))}

            {/* [SPACER] */}
            {pages[pages.length - 1] + 1 < lastPage && (
                <li className={styles.spacer}>...</li>
            )}

            {/* [LAST] */}
            {pages[pages.length - 1] < lastPage && (
                <li className={gcs(styles.page)}>
                    {onRenderPage(lastPage, false, lastPage)}
                </li>
            )}

            {/* [NEXT] */}
            {currentPage < lastPage && (
                <li className={gcs(styles.next)}>
                    {onRenderPage(currentPage + 1, false, t`pager.next.label`)}
                </li>
            )}

        </ol>
    );
}

BasePager.defaultProps = {
    className: '',
    currentPage: 1,
};

BasePager.propTypes = {
    className: PropTypes.string,
    currentPage: PropTypes.number,
    lastPage: PropTypes.number.isRequired,
    onRenderPage: PropTypes.func.isRequired,
}

export { BasePager };